import { ReactElement } from 'react'

import { Box, Container } from '@mui/material'
import Layout from 'layout'
import { commonPageStyles } from 'shared/common-styles'
import { withServerSideProps } from 'shared/withPageProps'
import PricingTable from '@/components/PricingTable/PricingTable'
import { useTheme } from '@mui/material/styles'
import { PricingContentData } from 'utils/content'

import { TextBlock, FreeTrial } from '@/components/simplified'

declare global {
	// eslint-disable-next-line @typescript-eslint/no-namespace
	namespace JSX {
		interface IntrinsicElements {
			'stripe-pricing-table': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>
		}
	}
}

export const getServerSideProps = withServerSideProps(async () => {
	return {
		props: {}
	}
})

export default function Pricing() {
	const theme = useTheme()

	return (
		<>
			<Box sx={commonPageStyles.commonPages} />

			<Box
				sx={{
					backgroundColor: theme.palette.mode === 'dark' ? theme.palette.custom.main : theme.palette.grey[50]
				}}
			>
				<Container
					sx={{
						pt: 4,
						pb: 1
					}}
				>
					<TextBlock
						title={PricingContentData.title}
						content={PricingContentData.content}
						titleLevel={1}
						align="center"
						spacing="normal"
						maxWidth="800px"
					/>
				</Container>
			</Box>

			<PricingTable />

			<FreeTrial />
		</>
	)
}

Pricing.getLayout = function getLayout(page: ReactElement) {
	return (
		<Layout title="Pricing" isLoggedIn={page.props.isLoggedIn} user={page.props.user}>
			{page}
		</Layout>
	)
}
